import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const TagsInputIpFieldLayout = ({
  inputComponent,
  inputRef,
  layoutRef,
  scrollToBottom,
  tagComponents,
}) => {
  const [tagsLength, setTagsLength] = useState(0);

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy code
  useEffect(() => {
    if (layoutRef.current && tagsLength < tagComponents.length) {
      scrollToBottom();
      setTagsLength(tagComponents.length);
    }
  }, [tagComponents]);

  const handleClick = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
  };

  return (
    <div
      className='TagsInputIpFieldLayout'
      ref={layoutRef}
      onClick={handleClick}
    >
      {tagComponents}
      {inputComponent}
    </div>
  );
};

TagsInputIpFieldLayout.propTypes = {
  inputComponent: PropTypes.node,
  inputRef: PropTypes.object,
  layoutRef: PropTypes.object,
  scrollToBottom: PropTypes.func,
  tagComponents: PropTypes.node,
};

export const makeTagsInputIpFieldLayout =
  (inputRef, layoutRef, scrollToBottom) => (tagComponents, inputComponent) => (
    <TagsInputIpFieldLayout
      inputRef={inputRef}
      inputComponent={inputComponent}
      layoutRef={layoutRef}
      scrollToBottom={scrollToBottom}
      tagComponents={tagComponents}
    />
  );
